var spacer = function spacer(key) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$hideIfMobile = _ref.hideIfMobile,
    hideIfMobile = _ref$hideIfMobile === void 0 ? false : _ref$hideIfMobile,
    _ref$hideIfNotMobile = _ref.hideIfNotMobile,
    hideIfNotMobile = _ref$hideIfNotMobile === void 0 ? false : _ref$hideIfNotMobile;
  return {
    hideIfMobile,
    hideIfNotMobile,
    pageNumber: '...',
    spacer: true,
    key
  };
};
var pagesRolling = function pagesRolling(totalPages, currentPage) {
  var small = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var currentPageSafe = Number.isNaN(currentPage) ? 1 : currentPage;
  currentPageSafe = Math.max(Math.min(currentPageSafe, totalPages), 1);
  var rollingStart = small ? Math.max(currentPageSafe - 1, 1) : Math.max(currentPageSafe - 2, 1);
  var upperBoundStart = small ? Math.max(totalPages - 2, 1) : Math.max(totalPages - 4, 1);
  var start = Math.min(rollingStart, upperBoundStart);
  var pageNums = (small ? [start, start + 1, start + 2] : [start, start + 1, start + 2, start + 3, start + 4]).filter(page => page <= totalPages);
  var currentPageIndex = pageNums.indexOf(currentPageSafe);
  var isAtBeginning = currentPageIndex === 0;
  var isAtEnd = currentPageIndex === pageNums.length - 1;
  var calcHiddenOnMobile = index => {
    if (isAtBeginning) {
      return index > 2;
    }
    if (isAtEnd) {
      return index < pageNums.length - 1 - 2;
    }
    return index < currentPageIndex - 1 || index > currentPageIndex + 1;
  };
  return pageNums.map((pageNumber, index) => ({
    pageNumber,
    hideIfMobile: small ? false : calcHiddenOnMobile(index)
  }));
};
var pagesSmall = (totalPages, currentPage) => {
  if (currentPage <= 2) {
    return [{
      pageNumber: 1
    }, {
      pageNumber: 2
    }, spacer('right'), {
      pageNumber: Math.max(totalPages, 3)
    }].filter(page => 'spacer' in page ? totalPages > 3 : Number(page.pageNumber) <= totalPages);
  }
  if (currentPage >= totalPages - 1) {
    return [{
      pageNumber: 1
    }, spacer('left'), {
      pageNumber: totalPages - 1
    }, {
      pageNumber: totalPages
    }].filter((page, index) => {
      if ('spacer' in page) {
        return totalPages > 3;
      }
      return index === 0 ? true : Number(page.pageNumber) <= totalPages && Number(page.pageNumber) > 1;
    });
  }
  return [{
    pageNumber: 1
  }, spacer('left'), {
    pageNumber: currentPage
  }, spacer('right'), {
    pageNumber: totalPages
  }];
};
var pagesResponsive = (totalPages, currentPage) => {
  if (totalPages < 5) {
    return pagesSmall(totalPages, currentPage);
  }
  if (currentPage <= 3) {
    return [{
      pageNumber: 1
    }, {
      pageNumber: 2,
      hideIfMobile: currentPage === 3
    }, spacer('left', {
      hideIfNotMobile: true
    }), {
      pageNumber: 3,
      hideIfMobile: currentPage < 3
    }, {
      pageNumber: 4,
      hideIfMobile: true
    }, spacer('right', {
      hideIfMobile: currentPage < 3,
      hideIfNotMobile: totalPages <= 5
    }), {
      pageNumber: Math.max(totalPages, 5)
    }];
  }
  if (currentPage >= totalPages - 2) {
    return [{
      pageNumber: 1
    }, spacer('left', {
      hideIfNotMobile: totalPages <= 5
    }), {
      pageNumber: totalPages - 3,
      hideIfMobile: true
    }, {
      pageNumber: totalPages - 2,
      hideIfMobile: true
    }, spacer('right', {
      hideIfNotMobile: true,
      hideIfMobile: currentPage !== totalPages - 2
    }), {
      pageNumber: totalPages - 1,
      hideIfMobile: currentPage === totalPages - 2
    }, {
      pageNumber: totalPages
    }];
  }
  return [{
    pageNumber: 1
  }, spacer('left'), {
    pageNumber: currentPage - 1,
    hideIfMobile: true
  }, {
    pageNumber: currentPage
  }, {
    pageNumber: currentPage + 1,
    hideIfMobile: true
  }, spacer('right'), {
    pageNumber: totalPages
  }];
};
var pages = function pages(totalPages, currentPage) {
  var small = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return small ? pagesSmall(totalPages, currentPage) : pagesResponsive(totalPages, currentPage);
};
export { pages, pagesRolling };